export const apiBase = API_APP_PATH + "/v1"

export const schools = [
    '10X024',
    '10X045',
    '10X056',
    '11X542',
    '12X134',
    '12X195',
    '12X196',
    '12X211',
    '12X242',
    '12X341',
    '21K097',
    '21K199',
    '28Q354',
    '29Q034',
    '29Q238',
    '11X288',
    '11X509',
    '11X299',
    '11X508',
    '27Q273'
]

export function filterObservations(_observations, _components) {
    _observations.map(function(observation) {
        observation.componentsMeasured = _components['data'].filter(component => 
            component.MOTPID === observation.MOTPID).sort(function(a, b) {
                return a.MOTPComponentDescription < b.MOTPComponentDescription ? -1 : 1
            })
        return observation
    })
    return _observations
}

export function createTeacherObjects(teacherInfo, mappings, componentsData, observationsData) {

    let teacherObjects = teacherInfo.reduce((accumulator,currentValue) => {

        accumulator[String(currentValue.FiscalYear)] = {
            fiscalYear: currentValue.FiscalYear, 
            components: {}, 
            motpScore: currentValue.SL_MOTP_Score
        }

        const regex = /mean/

        for (let prop in currentValue) {

            if (regex.test(prop)) {

                let key = prop.split('_')[0].slice(-2)
                const keyMappings = mappings[key]
                let arr = []

                if (typeof keyMappings === 'object') {

                    for (let i=0; i < keyMappings.length; i++) {
                        let accumulator = componentsData.filter(f => f.MOTPComponentID == keyMappings[i] && f.FiscalYear === currentValue.FiscalYear)
                        arr.length > 0 ?  arr = arr.concat(accumulator) : arr = accumulator 
                    }

                } else {

                    arr = componentsData.filter(f => f.MOTPComponentID == keyMappings && f.FiscalYear === currentValue.FiscalYear && f.Rating)

                }

                const createComments = arr.map(m => {
                    const {MOTPDate, TimePeriod, EvaluatorName} = observationsData.find(o => o.MOTPID === m.MOTPID)
                    m.Date = MOTPDate
                    m.Class = TimePeriod
                    m.Observer = EvaluatorName
                    return m
                })

                accumulator[String(currentValue.FiscalYear)].components[key] = {
                    data: {
                        average: currentValue[prop]
                    },
                    comments: createComments
                }

            }
        }

        return accumulator

    }, {})

    return teacherObjects
}